import { FC, useContext, useRef, useEffect } from 'react'
import { useRouter } from 'next/router'

import Auth from 'store/auth'
import statisticContext from 'context/statisticsContext'

import { vkIframeAllow, TICK } from '../data'
import { postAxiosSingle } from 'pages/api/axios'
import { createQueryUnAuth } from './utils'

import iframeStyle from '../iframe.module.scss'

interface IVkVideo {
  videoLink: string
  materialId?: number | string
  materialType?: string
  noAnalytics?: boolean
  refPlayerOuter?: any
}

const VkVideo: FC<IVkVideo> = ({
  videoLink,
  materialId,
  materialType,
  noAnalytics,
  refPlayerOuter,
}) => {
  const socket = useContext(statisticContext)
  const interval = useRef<any>(null)
  const router = useRouter()
  const { fakeAuth } = Auth.useAuth()

  const refPlayer = useRef(null)
  const counterStartVK = useRef(0)

  const sendData = (eventName: string) => {
    if (Object.keys(socket).length) {
      socket?.sendEvent(eventName, {
        id: materialId,
        materialType: materialType,
        timestamp: Date.now(),
      })
    }
  }

  const handleStartVideo = (state: any) => {
    if (materialId && materialType) {
      sendData('playVideoRecord')
      if (counterStartVK.current === 0 && router.query.spec && fakeAuth)
        postAxiosSingle(createQueryUnAuth(router.query.spec), {}, { materialId, materialType })

      counterStartVK.current += 1
      interval.current = setInterval(() => sendData('playVideoRecord'), TICK)
    }
  }

  const handleEndVideo = () => {
    if (interval?.current) {
      sendData('pauseVideoRecord')
      clearInterval(interval.current)
    }
  }

  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://vk.com/js/api/videoplayer.js'
    script.async = true

    script.onload = () => {
      const VK = (window as any).VK
      if (VK) {
        const player = VK.VideoPlayer(refPlayer.current)
        if (refPlayerOuter) refPlayerOuter.current = player
        if (!noAnalytics) {
          player.on('started', handleStartVideo)
          player.on('resumed', handleStartVideo)
          player.on('ended', handleEndVideo)
          player.on('paused', handleEndVideo)
        }
      }
    }
    document.body.appendChild(script)
    return () => {
      document.body.removeChild(script)
    }
  }, [refPlayer.current])

  useEffect(() => {
    return () => {
      if (interval?.current) {
        sendData('pauseVideoRecord')
        clearInterval(interval.current)
      }
    }
  }, [])

  return (
    <iframe
      src={`${videoLink}&js_api=1`}
      allow={vkIframeAllow}
      className={iframeStyle.playerIframe}
      ref={refPlayer}
    ></iframe>
  )
}

export default VkVideo
